/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { PureComponent } from 'react';
import './Dashboard.scss';
import _ from 'lodash';
import connect from 'shared/context/connect';
import { injectIntl } from 'react-intl';
import Fuse from 'fuse.js';
import { CheckMark } from 'components';
import {
  APP_STATUS_MAPPING, APP_STATUS, ONBOARDING_CATEGORY_MAPPING, EXCEL_DOWNLOAD,
} from 'shared/constants';
import moment from 'moment-timezone';
import {
  selectItem, getDashboardSummary, getApplicantTimeStamp, updateApplicantStatus, getFilePdfAction,
  getImageAction, getExcelAction, getPDFSimulationAction, generateOtpAction, resetItem, getLanguage,
  onValidateToken,
} from 'shared/context/actions';
import excelIconOn from 'assets/icons/icons8-microsoft-excel.svg';
import excelIconOff from 'assets/icons/icons8-microsoft-excel-inactive.svg';
import { toast } from 'react-toastify';
import numeral from 'numeral';
import {
  Navbar, Filter, UpdateAppStatusPopup, Table, GenerateOTPPopup,
} from './components';
import sortArrow from '../../assets/icons/sort-arrow.svg';

const START_DAY_SORT = 1;
const LAST_MODIFIED_DAY_SORT = 2;
const LASTEST_STAGE_SORT = 3;
const STATUS_SORT = 4;

const statusMap = {
  'NW-MAR-ON-BOARD': 1,
  'NW-MAR-COMPLETE': 2,
  'NW-MAR-ON-CANCEL': 3,
};

interface Props {
    intl: { formatMessage },
    summary,
    detail,
    onGetDashboardSummary,
    onSelectItem,
    onGetApplicantTimeStamp,
    onUpdateApplicantStatus,
    onGetFilePdfAction,
    onGetImageAction,
    onGetExcelAction,
    onGetPDFSimulationAction,
    onGenerateOtpAction,
    onResetItem,
    onGetLanguage,
    onTokenValidation,
    clientData: any,
}

interface State {
    isShowPopup: boolean,
    searchText: string,
    filterBy,
    filteredData,
    isAscSortStartDay,
    isAscSortLastModifiedDay,
    isAscLatestStageCompleted,
    isAcsStatus,
    latestSort,
    isShowOtp: boolean,
}

class Dashboard extends PureComponent<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopup: false,
      filterBy: [],
      searchText: '',
      filteredData: [],
      isAscSortStartDay: false,
      isAscSortLastModifiedDay: true,
      isAscLatestStageCompleted: false,
      isAcsStatus: false,
      latestSort: LAST_MODIFIED_DAY_SORT,
      isShowOtp: false,
    };
  }

  componentDidMount = async () => {
    const {
      onGetDashboardSummary, onGetLanguage, onTokenValidation, clientData,
    } = this.props;
    onGetDashboardSummary();
    onGetLanguage();
    onTokenValidation(clientData?.token);
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { summary } = this.props;
    const { latestSort, isShowPopup } = this.state;
    if (summary !== prevProps.summary) {
      this.setState({ filteredData: this.getFiltered(summary) }, () => {
        switch (latestSort) {
          case START_DAY_SORT:
            this.sortStartDay(true);
            break;
          case LASTEST_STAGE_SORT:
            this.sortStep(true);
            break;
          case LAST_MODIFIED_DAY_SORT:
            this.sortLastModifiedDay(true);
            break;
          case STATUS_SORT:
            this.sortStatus(true);
        }
      });
    }
    // refresh data when popup close
    if (isShowPopup !== prevState.isShowPopup && !isShowPopup) {
      const { onGetDashboardSummary } = this.props;
      onGetDashboardSummary();
    }
  }

  handleSelectFilter = (e) => {
    const { filterBy } = this.state;
    const filter = [...filterBy];
    if (filterBy.includes(e.target.name)) {
      _.remove(filter, (item) => item === e.target.name);
    } else {
      filter.push(e.target.name);
    }
    this.setState({ filterBy: filter }, () => this.handleSelectItem());
  }

  handleSearchFilter = (e) => {
    this.setState({ searchText: e.target.value }, () => this.handleSelectItem());
  }

  handleSelectItem = async (id = '') => {
    const { onSelectItem } = this.props;
    await onSelectItem(id);
  }

  getFiltered = (summary) => {
    const { filterBy, searchText } = this.state;
    const list = summary
      .map((x) => ({ ...x, applicantStatus: (x.applicantStatus || { status: '' }) }))
      .filter((item) => (filterBy.length ? filterBy.includes(item.applicantStatus.status) : item));

    const options = {
      shouldSort: true,
      matchAllTokens: true,
      findAllMatches: true,
      includeScore: true,
      threshold: 0,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['civilId', 'firstName', 'lastName', 'passport'],
    };
    const fuse = new Fuse(list, options);
    const result = searchText ? fuse.search(searchText) : list;
    return searchText ? result.map((x) => ({ ...x.item })) : list;
  }

  handleUpdateAppStatus = (data) => {
    const { intl: { formatMessage }, onUpdateApplicantStatus } = this.props;
    onUpdateApplicantStatus(data)
      .then((res) => {
        console.log('res.status', res.status, data.status);
        if (res.status === 200) {
          switch (data.status) {
            case APP_STATUS.ONGOING:
              toast.success(formatMessage({ id: 'dashboard.updateApp.appStatus.success.onboarding' }));
              break;
            case APP_STATUS.COMPLETED:
              toast.success(formatMessage({ id: 'dashboard.updateApp.appStatus.success.completed' }));
              break;
            case APP_STATUS.CANCELLED:
              toast.error(formatMessage({ id: 'dashboard.updateApp.appStatus.success.cancelled' }));
              break;
          }
        }

        this.setState({ isShowPopup: false });
      }).catch(({ response }) => {
        toast.error(formatMessage({ id: 'dashboard.updateApp.appStatus.error' }));
      });
  }

  sortStep = (useOldCondition) => {
    const { isAscLatestStageCompleted } = this.state;
    const toSort = useOldCondition ? !isAscLatestStageCompleted : isAscLatestStageCompleted;
    const summary = this.sortAlphabet('latestStageCompleted', toSort);
    this.setState((prevSate) => ({
      filteredData: summary,
      isAscLatestStageCompleted: !toSort,
      isAscSortStartDay: false,
      latestSort: LASTEST_STAGE_SORT,
    }));
  }

  sortStatus= (useOldCondition) => {
    const { isAcsStatus } = this.state;
    const toSort = useOldCondition ? !isAcsStatus : isAcsStatus;
    const summary = this.sortStatusByOrder(toSort);
    this.setState((prevSate) => ({
      filteredData: summary,
      isAcsStatus: !toSort,
      isAscSortStartDay: false,
      isAscSortLastModifiedDay: false,
      isAscLatestStageCompleted: false,
      latestSort: STATUS_SORT,
    }));
  }

  sortStartDay = (useOldCondition) => {
    const { isAscSortStartDay } = this.state;
    const toSort = useOldCondition ? !isAscSortStartDay : isAscSortStartDay;
    const summary = this.sortDay('cobStartDate', toSort);

    this.setState((prevSate) => ({
      filteredData: summary,
      isAscSortStartDay: !toSort,
      isAscLatestStageCompleted: false,
      isAscSortLastModifiedDay: false,
      isAcsStatus: false,
      latestSort: START_DAY_SORT,
    }));
  }

  sortLastModifiedDay = (useOldCondition) => {
    const { isAscSortLastModifiedDay } = this.state;
    const toSort = useOldCondition ? !isAscSortLastModifiedDay : isAscSortLastModifiedDay;
    const summary = this.sortDay('lastModified', toSort);

    this.setState((prevSate) => ({
      filteredData: summary,
      isAscSortLastModifiedDay: !toSort,
      isAscLatestStageCompleted: false,
      isAscSortStartDay: false,
      isAcsStatus: false,
      latestSort: LAST_MODIFIED_DAY_SORT,
    }));
  }

  sortDay = (dateField, isAsc) => {
    const { filteredData } = this.state;
    const summary = [...filteredData];

    summary.sort((a, b) => {
      if (a[dateField] && !b[dateField]) {
        return -1;
      } if (!a[dateField] && b[dateField]) {
        return 1;
      }
      const firstPhone = (a.applicantPhoneNumbers && _.first(a.applicantPhoneNumbers).phoneNumber) || '';
      const secondPhone = (b.applicantPhoneNumbers && _.first(b.applicantPhoneNumbers).phoneNumber) || '';
      if (isAsc) {
        return a[dateField] < b[dateField] ? -1 : a[dateField] > b[dateField] ? 1 : firstPhone < secondPhone ? -1 : firstPhone > secondPhone ? 1 : 0;
      }
      return a[dateField] < b[dateField] ? 1 : a[dateField] > b[dateField] ? -1 : firstPhone < secondPhone ? -1 : firstPhone > secondPhone ? 1 : 0;
    });
    return summary;
  }

  sortStatusByOrder = (isAsc) => {
    const { filteredData } = this.state;
    const summary = [...filteredData];

    summary.sort((a, b) => {
      const first = a.applicantStatus ? a.applicantStatus.status ? statusMap[a.applicantStatus.status] : 0 : 0;
      const second = b.applicantStatus ? b.applicantStatus.status ? statusMap[b.applicantStatus.status] : 0 : 0;
      const firstPhone = (a.applicantPhoneNumbers && _.first(a.applicantPhoneNumbers).phoneNumber) || '';
      const secondPhone = (b.applicantPhoneNumbers && _.first(b.applicantPhoneNumbers).phoneNumber) || '';
      if (isAsc) {
        return first < second ? -1 : first > second ? 1 : firstPhone < secondPhone ? -1 : firstPhone > secondPhone ? 1 : 0;
      }
      return first < second ? 1 : first > second ? -1 : firstPhone < secondPhone ? -1 : firstPhone > secondPhone ? 1 : 0;
    });
    return summary;
  }

  sortAlphabet = (field, isAsc) => {
    const { filteredData } = this.state;
    const summary = [...filteredData];

    summary.sort((a, b) => {
      if (a[field] && !b[field]) {
        return -1;
      } if (!a[field] && b[field]) {
        return 1;
      }
      const firstPhone = (a.applicantPhoneNumbers && _.first(a.applicantPhoneNumbers).phoneNumber) || '';
      const secondPhone = (b.applicantPhoneNumbers && _.first(b.applicantPhoneNumbers).phoneNumber) || '';
      if (isAsc) {
        return (a[field] < b[field]) ? -1 : (a[field] > b[field]) ? 1 : firstPhone < secondPhone ? -1 : firstPhone > secondPhone ? 1 : 0;
      }
      return (a[field] < b[field]) ? 1 : (a[field] > b[field]) ? -1 : firstPhone < secondPhone ? -1 : firstPhone > secondPhone ? 1 : 0;
    });
    return summary;
  }

  render() {
    const {
      intl: { formatMessage }, onGetApplicantTimeStamp, detail, onGetFilePdfAction,
      onGetImageAction, onGetExcelAction, onGetPDFSimulationAction, onGenerateOtpAction,
      onResetItem,
    } = this.props;
    const {
      isShowPopup, filterBy, searchText, filteredData, isAscSortStartDay, isAscSortLastModifiedDay, isAcsStatus, isAscLatestStageCompleted, isShowOtp,
    } = this.state;
    // console.log('filteredData', detail);
    return (
      <main className="dashboard">
        <Navbar onShowOtpPopup={() => this.setState({ isShowOtp: true })} />
        <GenerateOTPPopup
          showOtpPopup={isShowOtp}
          onClose={() => this.setState({ isShowOtp: false })}
          onGenerateOtp={onGenerateOtpAction}
        />
        <UpdateAppStatusPopup
          showModal={isShowPopup}
          onClose={() => this.setState({ isShowPopup: false })}
          detail={detail}
          onGetApplicantTimeStamp={onGetApplicantTimeStamp}
          onUpdateApplicantStatus={this.handleUpdateAppStatus}
          onGetFilePdfAction={onGetFilePdfAction}
          onGetImageAction={onGetImageAction}
          onGetPDFSimulationAction={onGetPDFSimulationAction}
        />
        <div className="dashboard__content">
          <Filter
            isDisabledPopup={!Object.keys(detail).length}
            onShowUpdatePopup={async () => {
              await onResetItem();
              this.setState({ isShowPopup: true });
            }}
            searchText={searchText}
            handleSearchFilter={this.handleSearchFilter}
            filterBy={filterBy}
            handleSelectFilter={this.handleSelectFilter}
          />
          <Table>
            <Table.Header>
              <tr>
                {/* Placeholder header for checkmark */}
                <th />
                <th style={{ textAlign: 'left' }}>{formatMessage({ id: 'dashboard.table.name' })}</th>
                <th style={{ textAlign: 'left' }}>{formatMessage({ id: 'dashboard.table.civilID' })}</th>
                <th style={{ textAlign: 'left' }}>{formatMessage({ id: 'dashboard.table.phoneNo' })}</th>
                {/* <th style={{ textAlign: 'center' }}>{formatMessage({ id: 'dashboard.table.clientBeneficiary' })}</th> */}
                <th style={{ textAlign: 'center' }}>{formatMessage({ id: 'dashboard.table.onBoardingategory' })}</th>
                <th style={{ textAlign: 'left' }}>{formatMessage({ id: 'dashboard.table.product' })}</th>
                <th style={{ textAlign: 'left' }}>{formatMessage({ id: 'dashboard.table.amount' })}</th>
                <th onClick={() => this.sortStep(false)} className="dashboard-sort" style={{ textAlign: 'center' }}>
                  {formatMessage({ id: 'dashboard.table.latestStageCompleted' })}
                  <div className="dashboard-sort-icon-container" style={isAscLatestStageCompleted ? { transform: 'rotate(180deg)' } : {}}>
                    <img src={sortArrow} alt="sort arrow" />
                  </div>
                </th>
                <th onClick={() => this.sortStartDay(false)} className="dashboard-sort">
                  {formatMessage({ id: 'dashboard.table.COBStartDate' })}

                  <div className="dashboard-sort-icon-container" style={isAscSortStartDay ? { transform: 'rotate(180deg)' } : {}}>
                    <img src={sortArrow} alt="sort arrow" />
                  </div>
                </th>
                <th onClick={() => this.sortLastModifiedDay(false)} className="dashboard-sort" style={{ textAlign: 'left' }}>
                  {formatMessage({ id: 'dashboard.table.lastModified' })}
                  <div className="dashboard-sort-icon-container" style={isAscSortLastModifiedDay ? { transform: 'rotate(180deg)' } : {}}>
                    <img src={sortArrow} alt="sort arrow" />
                  </div>
                </th>
                <th onClick={() => this.sortStatus(false)} className="dashboard-sort" style={{ textAlign: 'center' }}>
                  {formatMessage({ id: 'dashboard.table.applicationStatus' })}
                  <div className="dashboard-sort-icon-container" style={isAcsStatus ? { transform: 'rotate(180deg)' } : {}}>
                    <img src={sortArrow} alt="sort arrow" />
                  </div>
                </th>
                <th style={{ textAlign: 'left' }}>{formatMessage({ id: 'dashboard.table.markazComment' })}</th>
                {/* Placeholder header for file */}
                <th style={{ textAlign: 'left' }} />
              </tr>
            </Table.Header>
            <Table.Body>
              {filteredData.map((item, idx) => {
                const { applicantPhoneNumbers, applicantStatus, allStepsFinished } = item;
                const phone = (applicantPhoneNumbers && _.first(applicantPhoneNumbers).phoneNumber) || '';
                return (
                  <tr key={idx} className={allStepsFinished ? 'dashboard__content--completed' : ''}>
                    <td>
                      <CheckMark
                        id={item.id}
                        onCheckMarkChange={() => this.handleSelectItem(item.id)}
                        isChecked={item.isChecked}
                      />
                    </td>
                    <td className="dashboard__content--highlight">{item.fullName ? `${item.fullName}` : 'undefined'}</td>

                    <td>{item.civilId}</td>
                    <td>{(applicantPhoneNumbers && _.first(applicantPhoneNumbers).phoneNumber) || ''}</td>
                    {/* <td>{(applicantStatus && applicantStatus.clientBeneficiary) || ''}</td> */}
                    <td>{item.clientClassification ? formatMessage({ id: ONBOARDING_CATEGORY_MAPPING[item.clientClassification] }) : ''}</td>
                    <td>{item?.productName}</td>
                    <td>{item.investedAmount ? numeral(item.investedAmount).format('0,0') : '-' }</td>

                    <td>{item.latestStageCompleted || ''}</td>
                    <td>{item.cobStartDate ? moment(item.cobStartDate).tz('Asia/Kuwait').format('DD/MM/YYYY HH:mm:ss') : ''}</td>
                    <td>{item.lastModified ? moment(item.lastModified).tz('Asia/Kuwait').format('DD/MM/YYYY HH:mm:ss') : ''}</td>
                    <td>{(applicantStatus && applicantStatus.status) ? formatMessage({ id: APP_STATUS_MAPPING[applicantStatus.status] }) : ''}</td>
                    <td>{(applicantStatus && applicantStatus.comment) || ''}</td>
                    <td>
                      {
                        item.excelAvailable && applicantStatus && applicantStatus.status === APP_STATUS.COMPLETED
                          ? <img className="dashboard__content--link" src={excelIconOn} alt="markaz excel" onClick={() => onGetExcelAction(EXCEL_DOWNLOAD.url, EXCEL_DOWNLOAD.name, phone)} />
                          : <img src={excelIconOff} alt="markaz excel" />
                      }
                    </td>
                  </tr>
                );
              })}
            </Table.Body>
          </Table>
        </div>
      </main>
    );
  }
}

const mapStateToProps = ({ rootState, dashboard }) => ({
  summary: dashboard.summary,
  detail: dashboard.detail,
  clientData: rootState.clientData,
});

const mapDispatchToProps = ({
  onGetDashboardSummary: getDashboardSummary,
  onGetLanguage: getLanguage,
  onSelectItem: selectItem,
  onGetApplicantTimeStamp: getApplicantTimeStamp,
  onUpdateApplicantStatus: updateApplicantStatus,
  onGetFilePdfAction: getFilePdfAction,
  onGetImageAction: getImageAction,
  onGetExcelAction: getExcelAction,
  onGetPDFSimulationAction: getPDFSimulationAction,
  onGenerateOtpAction: generateOtpAction,
  onResetItem: resetItem,
  onTokenValidation: onValidateToken,
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Dashboard));
